import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import Loader from '../components/Loader';
import LoginPageLink from './LoginPageLink';
import { onboardingPath, safeReturnPath } from '../auth/returnPath';
import { ENTRA_LANDING_STATE } from '../auth/useEntraBackGuard';
import './AuthStatusPage.scss';

export default function EntraCallback() {
  const {
    authError,
    authMethod,
    authToken,
    isInitialized,
    lastAuthResult,
    signInWithAnotherAccount,
    user,
  } = useContext(UserContext);

  if (authError) {
    // E.g. the email already has a password account (no automatic linking), or
    // the account isn't allowed in the current rollout mode.
    return (
      <div className="auth-status-page" dir="rtl">
        <h1>ההתחברות לא הושלמה</h1>
        <p role="alert">{authError}</p>
        {/* Signs out of Microsoft and returns to /login, to try another account
            (the same invitation, the same return path). */}
        <button type="button" className="auth-status-primary" onClick={() => signInWithAnotherAccount()}>
          התחברות עם חשבון אחר
        </button>
        <LoginPageLink />
      </div>
    );
  }

  // A move that Microsoft answered with an error keeps the legacy session
  // (auth/runtimeAuth settleMove); its popup shows the reason, as after a
  // refused link.
  if (authMethod === 'legacy') {
    return <Navigate replace to="/profile" />;
  }

  if (!authToken || !isInitialized || !lastAuthResult) {
    return <Loader isLoading={true} />;
  }

  // Return where the user was going: the page that sent them to /login, or the
  // page that asked for two-step verification. Same-site paths only, never a
  // sign-in page (auth/returnPath). A user who still needs onboarding gets
  // there after it.
  const returnTo = safeReturnPath(lastAuthResult.returnTo);
  // The landing page is marked so Back from it stays put instead of returning
  // to Microsoft's pages, which would fail (auth/useEntraBackGuard).
  if (lastAuthResult.isNew || ['profile', 'workplace'].includes(user?.entraOnboarding?.status)) {
    const notice = lastAuthResult.invitationIgnored ? 'invitation_ignored' : null;
    return <Navigate replace to={onboardingPath({ returnTo, notice })} state={ENTRA_LANDING_STATE} />;
  }

  return <Navigate replace to={returnTo || '/homepage'} state={ENTRA_LANDING_STATE} />;
}
